(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-offer-bar')) {
    customElements.define(
      'announcement-offer-bar',
      class AnnouncementOfferBar extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
          this.currentIndex = Math.max(
            0,
            this.slides.findIndex((slide) => !slide.hidden)
          );

          if (this.slides.length < 2) return;

          this.previousButton = this.querySelector('[data-announcement-previous]');
          this.nextButton = this.querySelector('[data-announcement-next]');
          this.handlePrevious = () => this.selectSlide(this.currentIndex - 1);
          this.handleNext = () => this.selectSlide(this.currentIndex + 1);
          this.handleMouseEnter = () => this.stopRotation();
          this.handleMouseLeave = () => this.startRotation();
          this.handleFocusIn = () => this.stopRotation();
          this.handleFocusOut = (event) => {
            if (!this.contains(event.relatedTarget)) this.startRotation();
          };
          this.handleBlockSelect = (event) => {
            const selectedIndex = this.slides.indexOf(event.target);
            if (selectedIndex >= 0) {
              this.stopRotation();
              this.selectSlide(selectedIndex);
            }
          };

          this.previousButton.addEventListener('click', this.handlePrevious);
          this.nextButton.addEventListener('click', this.handleNext);
          this.addEventListener('mouseenter', this.handleMouseEnter);
          this.addEventListener('mouseleave', this.handleMouseLeave);
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          this.startRotation();
        }

        disconnectedCallback() {
          this.stopRotation();
          if (!this.previousButton || !this.nextButton) return;

          this.previousButton.removeEventListener('click', this.handlePrevious);
          this.nextButton.removeEventListener('click', this.handleNext);
          this.removeEventListener('mouseenter', this.handleMouseEnter);
          this.removeEventListener('mouseleave', this.handleMouseLeave);
          this.removeEventListener('focusin', this.handleFocusIn);
          this.removeEventListener('focusout', this.handleFocusOut);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        }

        selectSlide(index) {
          this.currentIndex = (index + this.slides.length) % this.slides.length;

          this.slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === this.currentIndex;
            slide.hidden = !isActive;
            slide.setAttribute('aria-hidden', String(!isActive));
          });
        }

        startRotation() {
          if (
            this.dataset.autoRotate !== 'true' ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
            this.rotationTimer
          ) {
            return;
          }

          const interval = Number.parseInt(this.dataset.rotationInterval, 10) || 5000;
          this.rotationTimer = window.setInterval(() => this.selectSlide(this.currentIndex + 1), interval);
        }

        stopRotation() {
          window.clearInterval(this.rotationTimer);
          this.rotationTimer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const initSection = (root) => {
      let section = null;

      if (root && root.matches && root.matches('[data-thriva-cart-section]')) {
        section = root;
      } else if (root && root.querySelector) {
        section = root.querySelector('[data-thriva-cart-section]');
      }

      if (!section || section.dataset.thrivaBound === 'true') return;
      section.dataset.thrivaBound = 'true';

      section.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.quantityTarget;
          if (!target) return;

          const input = section.querySelector(`[data-quantity-input="${target}"]`);
          if (!input) return;

          const step = Number(button.dataset.quantityChange || 0);
          const minimum = Number(input.min || 0);
          const nextValue = Math.max(minimum, Number(input.value || 0) + step);
          input.value = String(nextValue);
        });
      });
    };

    document.querySelectorAll('[data-thriva-cart-section]').forEach(initSection);

    document.addEventListener('shopify:section:load', (event) => {
      initSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const initSection = (root) => {
      if (!root || root.dataset.thrivaBound === 'true') return;
      root.dataset.thrivaBound = 'true';

      const mainImage = root.querySelector('[data-gallery-main]');
      const thumbs = root.querySelectorAll('[data-gallery-thumb]');

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.src = thumb.dataset.imageSrc || mainImage.src;
          if (thumb.dataset.imageSrcset) mainImage.srcset = thumb.dataset.imageSrcset;
          if (thumb.dataset.imageAlt) mainImage.alt = thumb.dataset.imageAlt;
        });
      });

      const quantityInput = root.querySelector('input[name="quantity"]');
      const quantityButtons = root.querySelectorAll('[data-quantity-change]');

      quantityButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!quantityInput) return;
          const step = Number(button.dataset.quantityChange || 0);
          const nextValue = Math.max(1, Number(quantityInput.value || 1) + step);
          quantityInput.value = String(nextValue);
        });
      });
    };

    document.querySelectorAll('[data-thriva-product-section]').forEach(initSection);

    document.addEventListener('shopify:section:load', (event) => {
      initSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
